import { gettext } from '@eventbrite/i18n';
import { formatMajorMoney } from '@eventbrite/intl';
import { ChoiceCard } from '@eventbrite/marmalade';
import classnames from 'classnames';
import React from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';
import defaultStyles from './EventInfoCard.module.scss';
import rebrandStyles from './EventInfoCard.rebrand.module.scss';
import EventPrice from './EventPrice/EventPrice';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};
interface EventInfoCardProps {
    className?: string;
    currency: string;
    currencyFormat: string;
    eventDate: string;
    eventImageSrc?: string;
    eventTitle?: string;
    isAppRebrandActive: boolean;
    onChange: () => void;
    onPaneToggle: () => void;
    eventDateOverride?: string;
    showEventPrice?: boolean;
    totalCostUnformatted: number;
}

const CHANGE = gettext('Change').toString();

const EventInfoCard: React.FC<EventInfoCardProps> = ({
    className,
    currency,
    currencyFormat,
    eventDate,
    eventImageSrc,
    eventTitle,
    isAppRebrandActive,
    onChange,
    onPaneToggle,
    eventDateOverride,
    showEventPrice = true,
    totalCostUnformatted,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    const formattedTotalCost = formatMajorMoney(
        totalCostUnformatted,
        currency,
        currencyFormat,
    );

    const ChangeCta =
        typeof onChange !== 'undefined' ? (
            <span onClick={onChange} className={styles.onChange}>
                {`${CHANGE}`}
            </span>
        ) : null;

    const eventPrice = showEventPrice ? (
        <EventPrice
            ticketPrice={formattedTotalCost}
            isAppRebrandActive={isAppRebrandActive}
            onPaneToggle={onPaneToggle}
        />
    ) : undefined;

    return (
        <ChoiceCard
            className={classnames(styles.card, className)}
            data-testid="event-info-card"
        >
            {eventImageSrc && (
                <div className={styles.imageWrapper}>
                    <img
                        src={eventImageSrc}
                        alt={String(eventTitle)}
                        loading="lazy"
                    />
                </div>
            )}

            <div className={styles.textInfo}>
                <p className={styles.title}>{eventTitle}</p>

                <p className={styles.dateWrapper}>
                    {eventDateOverride || eventDate}
                    {ChangeCta}
                </p>
                {eventPrice}
            </div>
        </ChoiceCard>
    );
};

export default EventInfoCard;
